import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import TaxPage from "../screens/Tax/TaxPage";
import EmulateUserPage from "../screens/EmulateUser/EmulateUserPage";
import PaymentPage from "../screens/Payment/PaymentPage";
import HomePage from "../screens/Home/HomePage";

const Stack = createStackNavigator();

const HomeStackNavigator = () => {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="Home"
        component={HomePage}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="Tax"
        component={TaxPage}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="EmulateUser"
        component={EmulateUserPage}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="Payments"
        component={PaymentPage}
        options={{ headerShown: false }}
      />
    </Stack.Navigator>
  );
};

export default HomeStackNavigator;
